import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import {
  SidebarMenu,
  SidebarMenuEmpty,
} from '@/features/legends/components/SidebarMenu'

export interface TemplatesSidebarProps {
  /**
   * `SidebarMenuItem`s.
   */
  children?: ReactNode
  isEmpty: boolean
  /**
   * Shows a button that adds a template.
   */
  onAdd?: () => unknown
  addTestId?: string
}

/**
 * The legend's templates, to pick the one to edit.
 */
export function TemplatesSidebar({
  children,
  isEmpty,
  onAdd,
  addTestId,
}: TemplatesSidebarProps) {
  return (
    <SidebarMenu
      title="Templates"
      footer={
        onAdd && (
          <Button
            label="New template"
            iconLeft="add"
            size="small"
            block
            onPress={onAdd}
            testId={addTestId}
          />
        )
      }
    >
      {isEmpty ? (
        <SidebarMenuEmpty>No templates yet.</SidebarMenuEmpty>
      ) : (
        children
      )}
    </SidebarMenu>
  )
}
